enum StarbucksConcept {
  Airport = 'airport',
  Grocery = 'grocery',
  College = 'college',
}

export { StarbucksConcept };
